import React from 'react';

interface SidePanelProps {
    children: React.ReactNode;
    visible: boolean;
    toggleAction: React.MouseEventHandler<HTMLDivElement>;
}

export const SidePanel = (props: SidePanelProps) => {
    return (
        <div className={props.visible ? 'sidepanel' : 'sidepanel sidepanel--hidden'}>
            <div className="sidepanel__spacer" onClick={props.toggleAction} />
            <div className="sidepanel__sidecontent">
                {props.children}
            </div>
        </div>
    );
}
